import React from 'react';
import {motion} from 'framer-motion';
import {CONFIG} from '../config/variables';
import {MEDIA} from '../config/media';

const Hero=()=> {
  const scrollToSection=(sectionId)=> {
    const element=document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({behavior: 'smooth'});
    }
  };

  return (
    <section 
      id="hero" 
      className="relative min-h-[92vh] sm:min-h-screen flex items-center justify-center overflow-hidden pt-20 sm:pt-0"
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <picture>
          <source
            media="(max-width: 639px)"
            srcSet={MEDIA.HERO_HOME_MOBILE.src}
          />
          <img
            src={MEDIA.HERO_HOME.src}
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-center"
            loading="eager"
            fetchpriority="high"
          />
        </picture>
        {/* Responsive Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/55 to-black/25 sm:bg-gradient-to-br sm:from-black/70 sm:via-black/50 sm:to-purple-900/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto"
        >
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            {CONFIG.PRIMARY_SERVICE} in {CONFIG.PRIMARY_LOCATION}
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-8 leading-relaxed">
            Turn website visitors into paying customers with a premium, SEO-optimised landing page built to earn trust and drive enquiries.
          </p>

          {/* Micro-benefits */}
          <div className="grid md:grid-cols-3 gap-4 mb-10 max-w-3xl mx-auto">
            {[
              'Direct response copywriting',
              'Mobile-first conversion paths',
              'Trust-first structure'
            ].map((benefit, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3 + index * 0.1 }}
                className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-4"
              >
                <p className="text-white font-medium">{benefit}</p>
              </motion.div>
            ))}
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <motion.button
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              onClick={() => scrollToSection('investment')}
              className="w-full sm:w-auto bg-gradient-to-r from-blue-500 to-purple-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:from-blue-600 hover:to-purple-700 transition-all duration-200 shadow-xl hover:shadow-2xl transform hover:scale-105"
            >
              Secure Your Landing Page
            </motion.button>
            <motion.button
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.7 }}
              onClick={() => scrollToSection('how-it-works')}
              className="w-full sm:w-auto bg-white/10 backdrop-blur-sm border border-white/30 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white/20 transition-all duration-200"
            >
              See How It Works
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;